<template>
    <v-card class="confirmation-modal" :loading="loading">
        <v-card-title class="header2">
            <slot name="header">
                <span>{{ title }}</span>
            </slot>
        </v-card-title>

        <v-card-text>
            <slot>{{ description }}</slot>
        </v-card-text>

        <v-card-actions>
            <slot
                name="actions"
                v-bind:loading="loading"
            >
                <v-btn class="v-btn--secondary" @click="cancel" :disabled="loading">{{ cancelBtnText }}</v-btn>
                <v-btn class="v-btn--red" @click="confirm" :disabled="loading">{{ confirmBtnText }}</v-btn>
            </slot>
        </v-card-actions>
    </v-card>
</template>

<script>
import {i18n} from "@/i18n";

export default {
    name: "ActionConfirmationCard",

    props: {
        title: {
            type: String,
            default: i18n.t('app.confirm_action'),
        },

        description: {
            type: String,
            default: i18n.t('app.confirm_action_warning'),
        },

        confirmTimeout: {
            type: Number,
            default: 0,
        },

        confirmBtnText: {
            type: String,
            default: i18n.t('app.delete'),
        },

        cancelBtnText: {
            type: String,
            default: i18n.t('app.cancel'),
        },

        loading: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        confirm() {
            this.$emit('confirm');
        },

        cancel() {
            this.$emit('cancel');
        }
    }
}
</script>

<style scoped>

</style>
